module.exports = __webpack_public_path__ + "static/media/sample_birthcertificate.fc38c6f3.jpg";